let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fthfF")).then(() => parcelRequire('2yxhK'));